// src/Components/StudentDetails.js
import React, { useState,useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import AppStrings from '../config/appstring';
import ClassSelect from '../Class/ClassSelect';
import SectionSelect from '../Class/Section';
import GenderSelect from '../Class/Gender';
import RegilionSelect from '../Class/Religion';
import AdmissionTypeSelect from '../Class/AdmissionType';
import BusSelect from '../Class/BusList';

const initialFormData = {
  ADMISSIONID: '',
  PRIMARYCONT: '',
  CLASS: '',
  SECTION: '',
  STUDENTNAME: '',
  LASTNAME: '',
  DOADM: '',
  GENDER: '',
  BLDGROUP: '',
  RELIGION: '',
  DOB: '',
  COMMUNITY: '',
  AADHAR: '',
  ADMISSION: '',
  NATIONALITY: '',
  C_ADD1: '',
  C_ADD2: '',
  C_CITY: '',
  C_PINCODE: '',
  C_COUNTRY: '',
  p_ADD1: '',
  p_ADD2: '',
  p_CITY: '',
  p_PINCODE: '',
  p_COUNTRY: '',
  F_NAME: '',
  F_MOBILENO: '',
  F_OCCUPATION: '',
  F_INCOME: '',
  F_OTHER_MOBILE: '',
  M_NAME: '',
  M_MOBILENO: '',
  M_OCCUPATION: '',
  M_INCOME: '',
  M_OTHER_MOBILE: '',
  G_NAME: '',
  G_MOBILENO: '',
  G_OCCUPATION: '',
  G_INCOME: '',
  G_RELATION: '',
  G_OTHER_MOBILE: '',
  SCHOOLNAME: '',
  ADDRESS: '',
  BOARD: '',
  MEDIUM: '',
  TCNUMBER: '',
  LAST_CLASS_PASSED: '',
  PERCENTAGE: '',
  TYPE: '',
  USERNAME: '',
  RESULT: '',
  sameAddress: false,
      DBNAME:'',
};

const selectedDB = localStorage.getItem('selectedDB');


const StudentDetails = ({AdmisID, user }) => {

 
  const [formData, setFormData] = useState({
    ADMISSIONID: '',
    PRIMARYCONT: '',
    CLASS: '',
    SECTION: '',
    STUDENTNAME: '',
    LASTNAME: '',
    DOADM: '',
    GENDER: '',
    BLDGROUP: '',
    RELIGION: '',
    DOB: '',
    COMMUNITY: '',
    AADHAR: '',
    ADMISSION: '',
    NATIONALITY: '',
    C_ADD1: '',
    C_ADD2: '',
    C_CITY: '',
    C_PINCODE: '',
    C_COUNTRY: '',
    p_ADD1: '',
    p_ADD2: '',
    p_CITY: '',
    p_PINCODE: '',
    p_COUNTRY: '',
    F_NAME: '',
    F_MOBILENO: '',
    F_OCCUPATION: '',
    F_INCOME: '',
    F_OTHER_MOBILE: '',
    M_NAME: '',
    M_MOBILENO: '',
    M_OCCUPATION: '',
    M_INCOME: '',
    M_OTHER_MOBILE: '',
    G_NAME: '',
    G_MOBILENO: '',
    G_OCCUPATION: '',
    G_INCOME: '',
    G_RELATION: '',
    G_OTHER_MOBILE: '',
    SCHOOLNAME: '',
    ADDRESS: '',
    BOARD: '',
    MEDIUM: '',
    TCNUMBER: '',
    LAST_CLASS_PASSED: '',
    PERCENTAGE: '',
    TYPE: '',
    USERNAME: user?.name||user,
    RESULT: '',
    ADDFEES:'',
    PLACE:'',
    SHIFT:'',
    BUSAMOUNT:'',
    DBNAME:selectedDB,
    //USERNAME:user?.name
  });
  
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', // clear error when typing
    }));
  };

  

  const validateForm = () => {
    const newErrors = {};
  
    // Required fields (you can add more based on your needs)
    if (!formData.STUDENTNAME.trim()) newErrors.STUDENTNAME = "First name is required";
    // if (!formData.LASTNAME.trim()) newErrors.LASTNAME = "Last name is required";
    // if (!formData.CLASS) newErrors.CLASS = "Class is required";
    // if (!formData.SECTION) newErrors.SECTION = "Section is required";
    // if (!formData.GENDER) newErrors.GENDER = "Gender is required";
    // if (!formData.DOB) newErrors.DOB = "Date of birth is required";
    // if (!formData.DOADM) newErrors.DOADM = "Admission date is required";
  
    return newErrors;
  };
  
  const handleSubmit = async () => {

       const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
     // alert('❌ Please fill all required fields');
      return;
    }


    try {
      console.log(formData,'LIST')
      const response = await fetch(AppStrings.StudentEntry, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success === 200) {
        alert('✅ ' + result.message);
        handleClear();
      } else {
        alert('❌ ' + result.message);
      }
    } catch (error) {
      console.error('Error:', error);
      alert('⚠️ Internal server error!');
    }
  };


  const [loading, setLoading] = useState(true); 
const [student, setStudent] = useState(null);

  useEffect(() => {
    
     console.log("Logged in as:", user?.name||user);
    const fetchStudent = async () => {
      try {
       // AdmisID='PRE KG24';
      // console.log(AdmisID,'BBBBBBBB')
        const response = await fetch(AppStrings.GetStudentDetails+`?studentid=${AdmisID}`);
        const result = await response.json();
//console.log(result.data[0],'kkkkkkkkkkkzzzzzzzzzzzzzzz');
//console.log(result.success,'sssssssssss')
        if (result.success && result.data[0]) {
          const studentData = result.data[0];
           setStudent(studentData);
              //  console.log(studentData,'RTTTTTTTTTTTTT');
          setFormData(prev => ({
            ...prev,
            ...studentData,
       

             ADMISSIONID:studentData.ADMISSIONID || '',
    PRIMARYCONT: studentData.PRIMARYCONT ||'',
    CLASS: studentData.CLASS ||'',
    SECTION:studentData.SECTION || '',
    STUDENTNAME:studentData.STUDENTNAME || '',
    LASTNAME:studentData.LASTNAME || '',
    DOADM: studentData.DOADM ||'',
    GENDER: studentData.GENDER ||'',
    BLDGROUP: studentData.BLDGROUP ||'',
    RELIGION: studentData.RELIGION ||'',
    DOB: studentData.DOB ||'',
    COMMUNITY: studentData.COMMUNITY ||'',
    AADHAR:studentData.AADHAR || '',
    ADMISSION:studentData.ADMISSION_TYPE || '',
    NATIONALITY: studentData.NATIONALITY ||'',
    C_ADD1: studentData.C_ADD1 ||'',
    C_ADD2:studentData.C_ADD2 || '',
    C_CITY:studentData.C_CITY || '',
    C_PINCODE: studentData.C_PINCODE ||'',
    C_COUNTRY: studentData.C_COUNTRY ||'',
    p_ADD1: studentData.P_ADD1 ||'',
    p_ADD2:studentData.P_ADD2 || '',
    p_CITY: studentData.P_CITY ||'',
    p_PINCODE: studentData.P_PINCODE ||'',
    p_COUNTRY:studentData.P_COUNTRY || '',
    F_NAME: studentData.F_NAME ||'',
    F_MOBILENO:studentData.F_MOBILENO || '',
    F_OCCUPATION:studentData.F_OCCUPATION || '',
    F_INCOME:studentData.F_INCOME || '',
    F_OTHER_MOBILE: studentData.F_OTHER_MOBILE ||'',
    M_NAME: studentData.M_NAME ||'',
    M_MOBILENO: studentData.M_MOBILENO ||'',
    M_OCCUPATION: studentData.M_OCCUPATION ||'',
    M_INCOME: studentData.M_INCOME ||'',
    M_OTHER_MOBILE: studentData.M_OTHER_MOBILE ||'',
    G_NAME: studentData.G_NAME ||'',
    G_MOBILENO:studentData.G_MOBILENO || '',
    G_OCCUPATION:studentData.G_OCCUPATION || '',
    G_INCOME: studentData.G_INCOME ||'',
    G_RELATION: studentData.G_RELATION ||'',
    G_OTHER_MOBILE: studentData.G_OTHER_MOBILE ||'',
    SCHOOLNAME:studentData.PREVIOUS_SCHOOLNAME || '',
    ADDRESS: studentData.PREVIOUS_SCHOOL_ADDRESS ||'',
    BOARD:studentData.PREVIOUS_SCHOOL_BOARD || '',
    MEDIUM:studentData.PREVIOUS_SCHOOL_MEDIUM || '',
    TCNUMBER: studentData.PREVIOUS_SCHOOL_TCNUMBER ||'',
    LAST_CLASS_PASSED: studentData.PREVIOUS_SCHOOL_LAST_CLASS_PASSED ||'',
    PERCENTAGE: studentData.PREVIOUS_SCHOOL_PERCENTAGE ||'',
    TYPE: studentData.TYPE ||'',
    USERNAME: user?.name||user,
    RESULT:studentData.RESULT || '',
    ADDFEES:studentData.ADDFEES ||'',
     PLACE:studentData.PLACE ||'',
    SHIFT:studentData.PICKUPTYPE ||'',
    BUSAMOUNT:studentData.BUS_AMOUNT ||'',
            // Optional: map DB keys to form keys if they mismatch
          }));
        } else {
          //alert('⚠️ Student data not found!');
        }
      } catch (error) {
        console.error('Error fetching student data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [user]);

  const handleClear = () => {
    setFormData(initialFormData);
    
  };

  const [openSection, setOpenSection] = useState(0);

  const toggleSection = (index) => {
    setOpenSection(openSection === index ? null : index);
  };
  


  

  const sections = [
    { title: '1. Personal Information', content: <PersonalInfo formData={formData} setFormData={setFormData} handleChange={handleChange} errors={errors}/> },
    { title: '2. Address Information', content: <AddressInfo formData={formData} setFormData={setFormData} handleChange={handleChange}/> },
    { title: '3. Parent/Guardian Details', content: <ParentInfo formData={formData} setFormData={setFormData} handleChange={handleChange}/> },
    { title: '4. Previous School Details', content: <Documents formData={formData} setFormData={setFormData} handleChange={handleChange}/> },
  ];

  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/dashboard.js'); // change this to your desired path
  };

  

  return (
    <div className="student-form">
      {sections.map((section, index) => (
        <div className="form-section" key={index}>
          <div className="section-header" onClick={() => toggleSection(index)}>
            {section.title}
          </div>
          <div className={`section-content ${openSection === index ? 'open' : ''}`}>
            {openSection === index && section.content}
          </div>
        </div>
      ))}
<div className="Buttonrow">
        
    
  {/* First Column */}
  <div className="Bcol-25">
    <div className="coolinput">
      <button onClick={handleSubmit}>
        <span>Save</span>
      </button>
    </div>
  </div>

  {/* Second Column */}
  <div className="Bcol-75">
    <div className="coolinput">
      <button onClick={handleClear}>
        <span>Clear</span>
      </button>
    </div>
  </div>

 
</div>

</div>
        
  );
};



const PersonalInfo =({ formData, setFormData,handleChange ,errors }) => {
  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split('T')[0];
  useEffect(() => {
    if (!formData.DOADM) { // Only set if DOADM is not already set
      setFormData(prevFormData => ({
        ...prevFormData,
        DOADM: today, // Set DOADM to current date
      }));
    }
  }, [formData, setFormData, today]); // Dependencies to run when formData or today changes


  return (
    <div>

<div className="row">
        <div className="col-25">
      
        <div class="coolinput">
      <label for="input" class="text">Admission:</label>
    <select type="text" placeholder="" name="ADDFEES"   value={formData.ADDFEES}
  onChange={handleChange}  autoComplete="off" class="input">
    <option value="">SELECT</option>
    <option value="MET">MATRIC</option>
    <option value="CBSE">CBSE</option>
    <option value="RTE">RTE</option>
    <option value="SCIRT">SCIRTE</option>
    </select>
    </div>
        </div>
        <div className="col-75">
       
        </div>
      </div>

<div className="row">
        <div className="col-25">
      
    {/* <label for="input" class="text">Class</label> */}
  
      {/* <p>Selected Class: {formData.CLASS}</p> */}
      <ClassSelect
        value={formData.CLASS} // Controlled value for the select dropdown
        onChange={handleChange} // Handle change to update formData
      />

        </div>
        <div className="col-75">
        <SectionSelect
        value={formData.SECTION} // Controlled value for the select dropdown
        onChange={handleChange} // Handle change to update formData
      />
        </div>
      </div>

      <div className="row">
        <div className="col-25">
        <div class="coolinput">
    <label for="input" class="text">First Name:</label>
    <input type="text" placeholder="" name="STUDENTNAME" value={formData.STUDENTNAME}
    onChange={handleChange}  autoComplete="off" class="input"/>
     {errors.STUDENTNAME && <span style={{ color: 'red' }}>{errors.STUDENTNAME}</span>}
</div>
        </div>
        <div className="col-75">
        <div class="coolinput">
    <label for="input" class="text">Last Name:</label>
    <input type="text" placeholder="" name="LASTNAME" value={formData.LASTNAME}
    onChange={handleChange}  autoComplete="off" class="input"/>
</div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          
          <div className="coolinput">
          <label for="input" class="text">Admission Date:</label>
            <input
              required
              type="date"
              name="DOADM"
              autoComplete="off"
              className="input"
              value={formData.DOADM}
              onChange={handleChange} 
            />
         
          </div>
        </div>
        <div className="col-75">
        <GenderSelect
        value={formData.GENDER} // Controlled value for the select dropdown
        onChange={handleChange} // Handle change to update formData
      />
        </div>
      </div>
      

      <div className="row">
        <div className="col-25">
        <div class="coolinput">
    <label for="input" class="text">Blood Group:</label>
    <input type="text" placeholder="" name="BLDGROUP"   value={formData.BLDGROUP}
  onChange={handleChange}  autoComplete="off" class="input"/>
</div>
        </div>
        <div className="col-75">
  
    <RegilionSelect
        value={formData.RELIGION} // Controlled value for the select dropdown
        onChange={handleChange} // Handle change to update formData
      />

        </div>
      </div>

      <div className="row">
        <div className="col-25">
          
          <div className="coolinput">
          <label for="input" class="text">Date Of Birth:</label>
            <input
              required
              type="DATE"
              name="DOB"
              autoComplete="off"
              className="input"
              value={formData.DOB}
              onChange={handleChange} 
            />
         
          </div>
        </div>
        <div className="col-75">
        <div class="coolinput">
    <label for="input" class="text">Community:</label>
    <input type="text" placeholder="" name="COMMUNITY"   value={formData.COMMUNITY}
  onChange={handleChange}  autoComplete="off" class="input"/>
</div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
        <div class="coolinput">
    <label for="input" class="text">Aadhar:</label>
    <input type="text" placeholder="" name="AADHAR"   value={formData.AADHAR}
  onChange={handleChange}  autoComplete="off" class="input"/>
</div>
        </div>
        <div className="col-75">
        <AdmissionTypeSelect
        value={formData.ADMISSION} // Controlled value for the select dropdown
        onChange={handleChange} // Handle change to update formData
      />
        </div>
      </div>

      <div className="row">
        <div className="col-25">
        <div class="coolinput">
    <label for="input" class="text">Nationlity:</label>
    <select type="text" placeholder="" name="NATIONALITY" 
     value={formData.NATIONALITY}
 onChange={handleChange}  autoComplete="off" class="input">
   <option value="">SELECT</option>
    <option value="INDIA">INDIA</option>
    </select>
    
</div>
        </div>
        <div className="col-75">
        <div class="coolinput">
    
    
</div>
        </div>
      </div>

    </div>
  );
};

const AddressInfo = ({ formData, setFormData,handleChange }) => {

   const [feeDetails, setFeeDetails] = useState([]);
   const [BUSAMOUNT, setBUSAMOUNT] = useState(null);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

   const handleShiftChange = (e) => {
    const selectedShift = e.target.value;
    setFormData(prev => ({
      ...prev,
      SHIFT: selectedShift,
    }));
    fetchFeeDetails(formData.PLACE, selectedShift);
  };

  const fetchFeeDetails = async (place, shift) => {
    if (!place || !shift) return;

    const url = AppStrings.VanFeesDetails + `?TYPE=${encodeURIComponent(shift)}&PLACE=${encodeURIComponent(place)}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      const feeArray = Array.isArray(data.data) ? data.data : data?.data?.result || [];
setBUSAMOUNT(feeArray[0].FEES);

 setFormData(prev => ({
      ...prev,
      BUSAMOUNT: feeArray[0]?.FEES || '0.00'  // fallback to '0.00'
    }));

      const formatted = feeArray.map(item => ({
        ...item,
        current: '',
        discount: '',
        discountType: '',
        discountRemark: ''
      }));
    

      setFeeDetails(formatted);
    } catch (error) {
      console.error('Error fetching fee data:', error);
      setFeeDetails([]);
    }
  };


  const handleCheckboxChange = () => {
    const checked = !formData.sameAddress;
    const updatedData = {
      ...formData,
      sameAddress: checked,
    };

    

    if (checked) {
      updatedData.p_ADD1 = formData.C_ADD1;
      updatedData.p_ADD2 = formData.C_ADD2;
      updatedData.p_CITY = formData.C_CITY;
      updatedData.p_PINCODE = formData.C_PINCODE;
      updatedData.p_COUNTRY = formData.C_COUNTRY;
    }

    setFormData(updatedData);
  };

  return (
    <div>
      {/* Current Address */}
      <div className="row">
        <div className="col-25">
          <label className="HeaderName">Current Address</label>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Address 1</label>
            <input
              type="text"
              name="C_ADD1"
              value={formData.C_ADD1}
              onChange={handleInputChange}
              className="input"
            />
          </div>
        </div>
        <div className="col-75">
          <div className="coolinput">
            <label className="text">Address 2</label>
            <input
              type="text"
              name="C_ADD2"
              value={formData.C_ADD2}
              onChange={handleInputChange}
              className="input"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">City</label>
            <input
              type="text"
              name="C_CITY"
              value={formData.C_CITY}
              onChange={handleInputChange}
              className="input"
            />
          </div>
        </div>
        <div className="col-75">
          <div className="coolinput">
            <label className="text">Pincode</label>
            <input
              type="text"
              name="C_PINCODE"
              value={formData.C_PINCODE}
              onChange={handleInputChange}
              className="input"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Country</label>
            <input
              type="text"
              name="C_COUNTRY"
              value={formData.C_COUNTRY}
              onChange={handleInputChange}
              className="input"
            />
          </div>
        </div>
      </div>

      <div className="row">
        
        <div className="col-25">
          <label for="input" class="text">Pick Up Place</label>
        <BusSelect
        value={formData.PLACE || ''}
        onChange={(e) => handleChange({ target: { name: 'PLACE', value: e.target.value } })}
        style={{ height: '40px' }}
      />

        </div>
        <label for="input" class="text">Type</label>
        <div className="col-75">
          
      <label style={{ marginRight: '10px' }}>
              <input
                type="radio"
                name="SHIFT"
                value="P"
                checked={formData.SHIFT === "P"}
                onChange={handleShiftChange}
              />
              Full
            </label>
            <label>
              <input
                type="radio"
                name="SHIFT"
                value="H"
                checked={formData.SHIFT === "H"}
                onChange={handleShiftChange}
              />
              Half
            </label>
             
  <input style={{ margin: '20px',color:'red',fontSize:'15px', border:'0',backgroundColor:'transparent' }}
              type="text"
              name="BUSAMOUNT"
              value={formData.BUSAMOUNT}
              onChange={handleInputChange}
            />
        </div>
        </div>
     

      {/* Checkbox for copying address */}
      <div className="row">
        <div className="col-25">
          <label className="text">
            <input
              type="checkbox"
              checked={formData.sameAddress || false}
              onChange={handleCheckboxChange}
            />{' '}
            Permanent address same as current
          </label>
        </div>
      </div>

      {/* Permanent Address */}
      <div className="row">
        <div className="col-25">
          <label className="HeaderName">Permanent Address</label>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Address 1</label>
            <input
              type="text"
              name="p_ADD1"
              value={formData.p_ADD1}
              onChange={handleInputChange}
              className="input"
              disabled={formData.sameAddress}
            />
          </div>
        </div>
        <div className="col-75">
          <div className="coolinput">
            <label className="text">Address 2</label>
            <input
              type="text"
              name="p_ADD2"
              value={formData.p_ADD2}
              onChange={handleInputChange}
              className="input"
              disabled={formData.sameAddress}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">City</label>
            <input
              type="text"
              name="p_CITY"
              value={formData.p_CITY}
              onChange={handleInputChange}
              className="input"
              disabled={formData.sameAddress}
            />
          </div>
        </div>
        <div className="col-75">
          <div className="coolinput">
            <label className="text">Pincode</label>
            <input
              type="text"
              name="p_PINCODE"
              value={formData.p_PINCODE}
              onChange={handleInputChange}
              className="input"
              disabled={formData.sameAddress}
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Country</label>
            <input
              type="text"
              name="p_COUNTRY"
              value={formData.p_COUNTRY}
              onChange={handleInputChange}
              className="input"
              disabled={formData.sameAddress}
            />
          </div>
        </div>
      </div>
    </div>
  );
};


const ParentInfo = ({ formData, setFormData, handleChange }) => {
  return (
    <div>
      {/* Father Details */}
      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="HeaderName">Father Details</label>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Father Name</label>
            <input
              type="text"
              name="F_NAME"
              value={formData.F_NAME}
              onChange={handleChange}
              autoComplete="off"
              className="input"
            />
          </div>
        </div>
        <div className="col-75">
          <div className="coolinput">
            <label className="text">Mobile No</label>
            <input
              type="text"
              name="F_MOBILENO"
              value={formData.F_MOBILENO}
              onChange={handleChange}
              autoComplete="off"
              maxLength="10"
              className="input"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Occupation</label>
            <input
              type="text"
              name="F_OCCUPATION"
              value={formData.F_OCCUPATION}
              onChange={handleChange}
              autoComplete="off"
              className="input"
            />
          </div>
        </div>
        <div className="col-75">
          <div className="coolinput">
            <label className="text">Annual Income</label>
            <input
              type="text"
              name="F_INCOME"
              value={formData.F_INCOME}
              onChange={handleChange}
              autoComplete="off"
              className="input"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Other Mobile</label>
            <input
              type="text"
              name="F_OTHER_MOBILE"
              value={formData.F_OTHER_MOBILE}
              onChange={handleChange}
              autoComplete="off"
              maxLength="10"
              className="input"
            />
          </div>
        </div>
      </div>

      {/* Mother Details */}
      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="HeaderName">Mother Details</label>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Mother Name</label>
            <input
              type="text"
              name="M_NAME"
              value={formData.M_NAME}
              onChange={handleChange}
              autoComplete="off"
              className="input"
            />
          </div>
        </div>
        <div className="col-75">
          <div className="coolinput">
            <label className="text">Mobile No</label>
            <input
              type="text"
              name="M_MOBILENO"
              value={formData.M_MOBILENO}
              onChange={handleChange}
              autoComplete="off"
              maxLength="10"
              className="input"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Occupation</label>
            <input
              type="text"
              name="M_OCCUPATION"
              value={formData.M_OCCUPATION}
              onChange={handleChange}
              autoComplete="off"
              className="input"
            />
          </div>
        </div>
        <div className="col-75">
          <div className="coolinput">
            <label className="text">Annual Income</label>
            <input
              type="text"
              name="M_INCOME"
              value={formData.M_INCOME}
              onChange={handleChange}
              autoComplete="off"
              className="input"
            />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label className="text">Other Mobile</label>
            <input
              type="text"
              name="M_OTHER_MOBILE"
              value={formData.M_OTHER_MOBILE}
              onChange={handleChange}
              autoComplete="off"
              maxLength="10"
              className="input"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Documents =  ({ formData, setFormData, handleChange }) => {
  return (
  <div>
    {/* <label>Upload Birth Certificate:</label>
    <input type="file" />
    <br />
    <label>Upload ID Proof:</label>
    <input type="file" /> */}


<div className="row">
        <div className="col-25">
        <div class="coolinput">
    <label for="input" class="text">School Name</label>
    <input type="text" placeholder=""  name="SCHOOLNAME"
              value={formData.SCHOOLNAME}
              onChange={handleChange} autoComplete="off" class="input"/>
</div>
        </div>
        <div className="col-75">
        <div class="coolinput">
    <label for="input" class="text">School Address</label>
    <input type="text" placeholder=""   name="ADDRESS"
              value={formData.ADDRESS}
              onChange={handleChange} autoComplete="off" class="input"/>
</div>
        </div>
      </div>
      <div className="row">
        <div className="col-25">
        <div class="coolinput">
    <label for="input" class="text">Board</label>
    <input type="text" placeholder=""  name="BOARD"
              value={formData.BOARD}
              onChange={handleChange} autoComplete="off" class="input"/>
</div>
        </div>
        <div className="col-75">
        <div class="coolinput">
    <label for="input" class="text">Medium</label>
    <input type="text" placeholder=""  name="MEDIUM"
              value={formData.MEDIUM}
              onChange={handleChange} autoComplete="off" class="input"/>
</div>
        </div>
      </div>
      <div className="row">
        <div className="col-25">
        <div class="coolinput">
    <label for="input" class="text">T.C. Number</label>
    <input type="text" placeholder=""   maxlength="10"  name="TCNUMBER"
              value={formData.TCNUMBER}
              onChange={handleChange} autoComplete="off" class="input"/>
</div>
        </div>
        <div className="col-75">
        <div class="coolinput">
        <label for="input" class="text">Last Class Passed</label>
        <input type="text" placeholder=""   maxlength="10"  name="LAST_CLASS_PASSED"
              value={formData.LAST_CLASS_PASSED}
              onChange={handleChange} autoComplete="off" class="input"/>
</div>
        </div>
      </div>
      <div className="row">
        <div className="col-25">
        <div class="coolinput">
    <label for="input" class="text">Percentage / Grade</label>
    <input type="text" placeholder=""   maxlength="10"  name="PERCENTAGE"
              value={formData.PERCENTAGE}
              onChange={handleChange} autoComplete="off" class="input"/>
</div>
        </div>
        <div className="col-75">
        <div class="coolinput">
    
</div>
        </div>
      </div>
  </div>
)
};

const BusFeesAmount = {
  color: '#C70039',
  fontWeight: 'bold',
   margin: '20px'
};

export default StudentDetails;
